import { CaseRunCalculateDetailModel, CaseRunClient, CaseRunDetailReadModel, LabCaseRunPrintOptionsModel } from '@app/api2/api';
import * as React from 'react';
import { Calculations } from './Calculations';
import { useOnLoadImages } from '@common/ImageHooks';
import { CaseRunDetailsPane } from '../Details/CaseRunDetailsPane';
import { MaxLrCaseRunResults } from '../Details/Results/MaxLR/MaxLrCaseRunResults';
import { SentryMatchResults } from '../Details/Results/Sentry/SentryMatchResults';
import { BPBoxWithHeader } from '@common/BPBoxWithHeader';
import { PrintContext } from './PrintContext';
import { usePromiseTracker } from 'react-promise-tracker';
import BPLoading from '@common/BPLoading';

interface ICaseRunPrintPageProps {
    labId: number;
    caseId: number;
    caseRunId: number;
}

export const CaseRunPrintPage: React.FunctionComponent<ICaseRunPrintPageProps> = (props) => {
    const client = new CaseRunClient();
    const [model, setModel] = React.useState(null as CaseRunDetailReadModel)
    const [calculations, setCalculations] = React.useState([] as CaseRunCalculateDetailModel[])
    const [imagesReady, setImagesReady] = React.useState(false)

    const printOptions = JSON.parse(window.sessionStorage.getItem(`print${props.caseRunId}`) ?? '{}') as LabCaseRunPrintOptionsModel;

    const { promiseInProgress } = usePromiseTracker();

    React.useEffect(() => {

        async function fetch() {
            const res = await client.getPrintDetails(props.labId, props.caseId, props.caseRunId)
            const res2 = await client.getCalculations(props.labId, props.caseId, props.caseRunId, 10000, 1, '', '', false)
            // const cal = []
            const calc = res2.items.map(item => {
                let res3 = client.getCalculationDetails(props.labId, props.caseId, props.caseRunId, item.id);
                return res3;
            })
            setCalculations(await Promise.all(calc))
            setModel(res)
        }

        fetch();
    }, [])

    React.useEffect(() => {
        if (!promiseInProgress && imagesReady) {
            setTimeout(() => {
                if (!promiseInProgress && imagesReady)
                    window.print()
            }, 1000)
        }
    }, [promiseInProgress, imagesReady])

    const canPrint = !promiseInProgress && imagesReady

    if (model == null)
        return <BPLoading active={!canPrint} />

    // const title = replaceInString(window.translation.caseRunView.runDetails, { '{runId}': model?.caseRunId, '{caseName}': model?.caseName });
    const isSentry = model.runType == 'dnamatch';

    return <ImgWaiter done={() => {
        setImagesReady(true)
    }}>
        <PrintContext.Provider value={printOptions}>
            <div className="output letter">
                <BPLoading active={!canPrint} />
                {/* {values.caseRunDetails && */}
                <CaseRunDetailsPane model={model} referenceUrls={{}} populationUrl={''} caseUrl='' evidenceUrls={{}} />
                {/* } */}
                {/* {values.resultsWeightOfEvidence && <> */}
                {!isSentry ? <MaxLrCaseRunResults {...props} /> : printOptions.sentryResults && <BPBoxWithHeader forPrint header={window.translation.common.results}><SentryMatchResults {...props} forPrint /></BPBoxWithHeader>}
                {/* </>} */}
                {/* {values.caseInformation && calculations.length > 0 && */}
                <Calculations model={model} calculations={calculations} />
                {/* } */}
            </div>

        </PrintContext.Provider>
    </ImgWaiter>;
};



interface IImgWaiterProps {
    children: any;
    done: () => void;
}

const ImgWaiter: React.FunctionComponent<IImgWaiterProps> = (props) => {
    const wrapperRef = React.useRef<HTMLDivElement>(null);
    const imagesLoaded = useOnLoadImages(wrapperRef);

    React.useEffect(() => {
        if (imagesLoaded)
            props.done()
    }, [imagesLoaded])

    return <div ref={wrapperRef}>{props.children}</div>;
};










